//V1.0.0
//Static singleton style
//Creates and instance of the app and allows access to
//Core.state.set('project.title', 'Market Masters');
import { App } from './App';
import { RouteManager } from 'core/router';
import { ModuleManager } from 'core/ModuleManager';
import { ControllerManager } from 'core/ControllerManager';

import { DOMHelper } from 'core/DOMHelper';
import { FrameworkHelper } from 'core/FrameworkHelper';

export class Core {
	public static app: App;

	public static get controller(): ControllerManager {
		return Core.app.controller;
	}

	public static get route(): RouteManager {
		return Core.app.route;
	}

	public static get module(): ModuleManager {
		return Core.app.module;
	}

	public static get DOM(): DOMHelper {
		return Core.app.DOM;
	}

	public static get framework(): FrameworkHelper {
		return Core.app.framework;
	}

	public static init(): void {
		Core.app.init();
	}
}

if (!Core.app) {
	Core.app = new App();
}
